import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = { class: "col-12" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("b", null, "Beratungszeit", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card-district-office", _ctx.classes]),
    ref: "root"
  }, [
    (_ctx.districtOffice !== null)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", {
            class: "card-district-office__title",
            innerHTML: _ctx.districtOffice.title
          }, null, 8, _hoisted_1),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("address", null, [
                _createTextVNode(_toDisplayString(_ctx.districtOffice.street) + " " + _toDisplayString(_ctx.districtOffice.streetNumber), 1),
                _hoisted_4,
                _createTextVNode(" " + _toDisplayString(_ctx.districtOffice.postcode) + " " + _toDisplayString(_ctx.districtOffice.city), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _hoisted_7,
              _createElementVNode("span", { innerHTML: _ctx.consultationTime }, null, 8, _hoisted_8)
            ])
          ])
        ], 64))
      : _createCommentVNode("", true)
  ], 2))
}